module.exports = __webpack_public_path__ + "static/media/997743.5cd6834f.jpg";